/** Resolves a reference to a resource without a hook, against the files already loaded. */
import { scopedSection } from './resourceSection';
import { parsedResourcePath, resolveSubResourceRef } from './SubResourceResolver';
/** The file `ref` loads from, or null for a SubResource, no reference, or a path no processor reads. */
export function referencedFilePath(ref, pools) {
    return parsedResourcePath(ref, pools.externalResources);
}
/** {@link resolveReference}, for a caller that needs only the resource and not its tables. */
export function resolveReferencedResource(ref, pools, loadedFile) {
    return resolveReference(ref, pools, loadedFile)?.resource ?? null;
}
/**
 * The resource `ref` names in `pools`: a SubResource in the tables, or the section of the loaded
 * file an ExtResource names, scoped to that file's own tables. Null for no reference, an unknown
 * id, or a file not loaded yet.
 */
export function resolveReference(ref, pools, loadedFile) {
    const inline = resolveSubResourceRef(ref, pools.internalResources);
    if (inline)
        return { resource: inline, resources: pools };
    const path = referencedFilePath(ref, pools);
    const parsed = path ? loadedFile(path) : undefined;
    return (path && parsed && scopedSection(parsed, path)) || null;
}
//# sourceMappingURL=resolveReference.js.map